<template>
  <div class="tg-pic-panel">
    <a :href="data.locationlink == null ? '/chinajoy/news/' + (data.id || data.nid) : data.locationlink">
      <tg-flexbox direction="column">
        <tg-flexbox flex="1"
                    class="tg-pic-panel_imgbox"><img :src="'https://xyoss.g.com.cn/xy-production' + data.banner"
               alt=""></tg-flexbox>
        <tg-flexbox class="tg-pic-panel_text">{{data.titlefull}}</tg-flexbox>
      </tg-flexbox>
    </a>
  </div>
</template>
<script>
export default {
  name: 'TgPicPanel',
  props: {
    data: Object,
    size: {
      type: String,
      default: '600_',
    },
  },
  data() { },
};
</script>
